import request from '@/utils/request'

/**
 * Get Cooperative Enterprise List (All)
 * @param {Object} params - Query parameters
 * @param {string} [params.cityCode] - City administrative code
 * @param {string} [params.districtCode] - District administrative code
 * @param {string} [params.enterpriseNature] - Enterprise nature (state_owned: State-owned, private: Private)
 * @param {string} [params.provinceCode] - Province administrative code
 * @returns {Promise}
 */
export function getAllEnterprises(params) {
  return request({
    url: '/api/frontend/enterprise/all',
    method: 'get',
    params
  })
}

/**
 * Get Recommended Enterprise List
 * Randomly queries 9 recommended enterprises for display and "change batch" functionality
 * @param {Object} params - Query parameters
 * @param {string} [params.cityCode] - City administrative code
 * @param {string} [params.districtCode] - District administrative code
 * @param {string} [params.enterpriseNature] - Enterprise nature (state_owned: State-owned, private: Private)
 * @param {string} [params.provinceCode] - Province administrative code
 * @returns {Promise}
 */
export function getRecommendedEnterprises(params) {
  return request({
    url: '/api/frontend/enterprise/recommend-list',
    method: 'get',
    params
  })
}

/**
 * Get Student Showcase List
 * @param {Object} params
 * @param {number} [params.pageNum]
 * @param {number} [params.pageSize]
 * @param {string} [params.studentName]
 */
export function getStudentShowcaseList(params) {
  return request({
    url: '/api/frontend/certificate-category/student-showcase-list',
    method: 'get',
    params
  })
}
